import { useState } from "react";

const DATA = [
  {
    label: "2021 baseline",
    value: 100,
    color: "#004778",
    note: "Emissions indexed to the plan's 2021 baseline (= 100).",
  },
  {
    label: "2050 target",
    value: 50,
    color: "#7EBC37",
    note: "The plan's goal: reduce 2021-level emissions by 50% by 2050.",
  },
  {
    label: "2050 aspirational",
    value: 20,
    color: "#FFA100",
    note: "Aspirational goal: an 80% reduction below 2021 levels.",
  },
];

export const EmissionsChart = () => {
  const [active, setActive] = useState(1);
  return (
    <figure
      className="mt-10 border border-[#004778]/25 bg-white"
      data-testid="story-emissions-chart"
    >
      <div className="border-b border-[#004778]/15 px-7 py-4">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#004778]">
          The Plan's Emissions Goal
        </p>
      </div>
      <div className="space-y-5 px-7 py-7" role="list">
        {DATA.map((d, i) => (
          <button
            key={d.label}
            type="button"
            role="listitem"
            onMouseEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onClick={() => setActive(i)}
            className="block w-full text-left"
            data-testid={`chart-bar-${i}`}
            aria-label={`${d.label}: ${d.note}`}
          >
            <span className="flex items-center justify-between text-xs font-bold uppercase tracking-[0.1em] text-[#022A42]">
              {d.label}
              <span className="harc-heading text-base font-semibold" style={{ color: d.color }}>
                {d.value === 100 ? "100" : `−${100 - d.value}%`}
              </span>
            </span>
            <span className="mt-1.5 block h-7 w-full bg-[#EEF3F5]">
              <span
                className="block h-full transition-all duration-500"
                style={{
                  width: `${d.value}%`,
                  background: d.color,
                  opacity: active === i ? 1 : 0.75,
                }}
              />
            </span>
          </button>
        ))}
        <p className="min-h-[2.5rem] text-sm leading-relaxed text-[#5C6B72]" aria-live="polite" data-testid="chart-note">
          {DATA[active].note}
        </p>
      </div>
      <figcaption className="border-t border-[#004778]/15 px-7 py-3 text-xs italic text-[#5C6B72]">
        Verified from the approved project description. Indexed values; absolute emissions figures
        [HARC CONTENT REQUIRED].
      </figcaption>
    </figure>
  );
};
